import React, { useCallback } from "react";
import PropTypes from "prop-types";

import Preline from "../../Atoms/Preline";
import Headline from "../../Atoms/Headline";
import Text from "../../Atoms/Text";
import LinkSwitcher from "../../Atoms/Link/LinkSwitcher";
import StandardComparisonGalleryItem from "./StandardComparisonGalleryItem";

const StandardComparisonGallery = ({
  properties: {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    comparisonCards,
    animation,
  },
}) => {
  const renderComparisonCards = useCallback(() => {
    return comparisonCards.map((comparisonCard) => {
      return (
        <StandardComparisonGalleryItem
          comparisonCard={comparisonCard}
          key={`key_${comparisonCard.header || Math.random()}`}
          animation={animation}
        />
      );
    });
  }, [comparisonCards, animation]);

  return (
    <div className="container comparison-gallery standard">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <Preline preline={subline} />

          <Headline headerType={headerType} headerStyle={headerDisplayStyle} headline={header} />

          {teaser && (
            <div className="mt-xsmall">
              <Text textType="text" text={teaser} />
            </div>
          )}

          {(headerLink || secondaryLink) && (
            <div className="mt-small" data-aos={animation.links.default}>
              <div className="links">
                <LinkSwitcher
                  linkType={headerLinkType}
                  link={headerLink}
                  // additionalClasses="btn-lg rounded-pill"
                />

                <LinkSwitcher linkType={secondaryLinkType} link={secondaryLink} />
              </div>
            </div>
          )}
        </div>
      </div>

      {comparisonCards.length > 0 && (
        <div className="mt-small">
          <div className="row justify-content-center g-4">{renderComparisonCards()}</div>
        </div>
      )}
    </div>
  );
};

StandardComparisonGallery.propTypes = {
  properties: PropTypes.instanceOf(Object),
};

export default StandardComparisonGallery;
